module.exports = __webpack_public_path__ + "static/img/cw.d0e9d598.svg";